import { Constants, Enums, Tools } from "../utils";
import Localization from "../localization";
import { Images } from "../assets";
import api from "./api";

const alarms = () =>
  new Promise(async (resolve) => {
    try {
      const data = [
        [
          {
            uuid: 101,
            name: "Verisure",
            vendor: "Verisure",
            desc: "Verisure",
            color: "destructive",
            integration: "verisure",
            terms: Localization.api.services.devices.terms,
          },
          {
            name: "Sector",
            vendor: "Sector",
            desc: "Sector",
            color: "destructive",
            integration: "sector",
          },
          {
            name: "Alert Alarm",
            vendor: "Alert Alarm",
            desc: "Alert Alarm",
            integration: "alert_alarm",
          },
        ],
        [
          {
            name: "Ajax",
            uuid: 120,
            integration: "ajax",
            vendor: "Ajax Systems",
            desc: "Ajax Systems",
            image: Images.AjaxAlarmSystem,
          },
          {
            uuid: 119,
            integration: "sms",
            image: Images.Sikkerthjem,
            vendor: "Sikkerthjem",
            desc: "Sikkerthjem",
            name: "SikkertHjem S6evo/S7evo",
          },

          {
            name: "YOYOCam 3G Indoor",
            uuid: 104,
            integration: "sms",
            vendor: "YOYO",
            desc: "YOYO",
            image: Images.YoyoCam,
          },
          // {
          //   name: "Arlo",
          //   uuid: 10001,
          //   integration: "http",
          //   vendor: "Arlo",
          //   desc: "Arlo",
          //   image: Images.Arlo,
          // },
          {
            name: "Nest Protect",
            uuid: 10002,
            integration: "http",
            vendor: "Nest",
            desc: "Nest",
            image: Images.NestProtect,
          },
          // {
          //   name: "Netatmo",
          //   uuid: 10003,
          //   integration: "http",
          //   vendor: "Netatmo",
          //   desc: "Netatmo",
          //   image: Images.Netatmo,
          // },
          // {
          //   name: "Nest Cam",
          //   uuid: 10006,
          //   integration: "http",
          //   vendor: "Nest",
          //   desc: "Nest",
          //   image: Images.NestCam,
          // },
          {
            name: "Point",
            uuid: 10008,
            integration: "http",
            vendor: "Minut",
            desc: "Minut",
            image: Images.Point,
          },
          {
            name: "Visonic PowerMaster 10",
            uuid: 100,
            integration: "sms",
            vendor: "Visonic",
            desc: "Visonic",
            image: Images.VisonicPowermaster,
          },
        ],
        [
          {
            uuid: 10000,
            vendor: "",
            integration: "http",
            name: Localization.purchase.alarm_list_footer_title,
            desc: Localization.purchase.alarm_list_footer_subtitle,
          },
        ],
      ];
      resolve(data);
    } catch (error) {}
  });

const alarm = async (uuid) => {
  const data = await alarms();
  return data.flat().find((_) => _.uuid === (uuid === 20002 ? 120 : uuid));
};

const device = async (uuid) =>
  new Promise(async (resolve, reject) => {
    try {
      const data = await api.get(`/rest/devices/${uuid}/configurations/events`);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });

const updateDeviceEvents = (uuid, params = {}) =>
  new Promise(async (resolve, reject) => {
    try {
      const data = await api.put(
        `/rest/devices/${uuid}/configurations/events`,
        { data: [params] }
      );
      resolve(data);
    } catch (error) {
      reject({ error });
    }
  });

const devicePackages = () =>
  new Promise(async (resolve) => {
    try {
      const data = [
        {
          image: Images.AjaxAlarmSystem,
          subTitle: Localization.general.ajax_systems,
          desc: Localization.api.services.devicePackages.premiumlarmet_desc,
          title: Localization.api.services.devicePackages.premiumlarmet_title,
          orderLink: Constants.Project.urls.ajax,
        },
      ];
      resolve(data);
    } catch (error) {}
  });

const paymentPlans = async (params = {}) => {
  const lang = Localization.getLanguage();
  const data = await api.get(`/rest/v5/services/paymentplans`, {
    params: { lang, ...params },
  });
  return data;
};

const services = () =>
  new Promise(async (resolve, reject) => {
    const userId = Tools.storage.getItem(Enums.storageKeys.userUuid);
    try {
      const data = await api.get(`/rest/v5/users/${userId}/services`);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });

const service = (uuid) =>
  new Promise(async (resolve, reject) => {
    const userId = Tools.storage.getItem(Enums.storageKeys.userUuid);
    try {
      const data = await api.get(`/rest/v5/users/${userId}/services/${uuid}`);
      resolve(data);
    } catch (_) {
      var error = {
        status: 500,
        message: Localization.feedback.something_wrong,
      };
      if (_.response.status === 404)
        error = {
          status: 404,
          message: Localization.feedback.ua_service,
        };
      reject(error);
    }
  });

const updateDevice = (uuid = "", options = {}) =>
  new Promise(async (resolve, reject) => {
    try {
      const data = await api.put(`/rest/devices/${uuid}`, { data: options });
      resolve(data);
    } catch (error) {
      if (error?.response?.status === 409)
        return reject({
          message:
            options?.type === Enums.deviceTypes.ajax
              ? Localization.feedback.hub_already_inuse
              : Localization.feedback.phone_already_inuse,
        });
      reject(error);
    }
  });

const arc = (uuid = "") =>
  new Promise(async (resolve, reject) => {
    const userId = Tools.storage.getItem(Enums.storageKeys.userUuid);
    try {
      const data = await api.get(
        `/rest/users/${userId}/services/${uuid}/arcinstructions`
      );
      resolve(data);
    } catch (error) {
      if (error?.response?.status === 404)
        return resolve({
          actions: [],
          contacts: [],
          customer: {},
        });
      reject(error);
    }
  });

const updateArc = (uuid = "", data = {}) =>
  new Promise(async (resolve, reject) => {
    const userId = Tools.storage.getItem(Enums.storageKeys.userUuid);
    try {
      await api.put(`/rest/users/${userId}/services/${uuid}/arcinstructions`, {
        data: {
          customer: data.customer,
          contacts: data.contacts,
          actions: data.actions,
        },
      });
      resolve();
    } catch (error) {
      reject(error);
    }
  });

const updateProgress = (uuid = "", data = {}) =>
  new Promise(async (resolve, reject) => {
    const userId = Tools.storage.getItem(Enums.storageKeys.userUuid);
    try {
      await api.put(`rest/users/${userId}/services/${uuid}/progress`, {
        data,
      });
      resolve();
    } catch (error) {
      reject(error);
    }
  });

const subscription = (sessionId) =>
  new Promise(async (resolve, reject) => {
    const userId = Tools.storage.getItem(Enums.storageKeys.userUuid);
    try {
      const data = await api.get(
        `rest/users/${userId}/subscriptions/checkout/${sessionId}`
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });

const subscriptionIntent = (subscriptionId, { service, name } = {}) =>
  new Promise(async (resolve, reject) => {
    const userId = Tools.storage.getItem(Enums.storageKeys.userUuid);
    try {
      const data = await api.post(`rest/users/${userId}/subscriptions/intent`, {
        data: {
          subscriptionId,
          service,
          paymentPlan: { name },
        },
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });

const delSubscription = (sessionId, { immediately = false } = {}) =>
  new Promise(async (resolve, reject) => {
    const userId = Tools.storage.getItem(Enums.storageKeys.userUuid);
    try {
      await api.delete(`/rest/users/${userId}/subscriptions/${sessionId}`, {
        params: { immediately },
      });
      resolve();
    } catch (error) {
      reject(error);
    }
  });

const reactivateSubscription = async (uuid) => {
  const userId = Tools.storage.getItem(Enums.storageKeys.userUuid);
  await api.post(`/rest/users/${userId}/services/${uuid}/reactivate`);
};

const license = (uuid) =>
  new Promise(async (resolve, reject) => {
    try {
      const data = await api.get(`rest/licenses/${uuid}`);
      resolve(data);
    } catch (error) {
      if (error?.response?.status === 404)
        error.message = Localization.feedback.invalid_license_key;
      reject(error);
    }
  });

const activateLicense = (licenseKey) =>
  new Promise(async (resolve, reject) => {
    const userId = Tools.storage.getItem(Enums.storageKeys.userUuid);

    try {
      const data = await api.post(`rest/users/${userId}/services`, {
        data: { licenseKey },
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });

const configured = (uuid) =>
  new Promise(async (resolve, reject) => {
    const userId = Tools.storage.getItem(Enums.storageKeys.userUuid);

    try {
      const data = await api.post(
        `/rest/users/${userId}/services/${uuid}/configured`
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });

export default {
  arc,
  alarm,
  alarms,
  device,
  license,
  service,
  services,
  updateArc,
  configured,
  subscription,
  updateDevice,
  paymentPlans,
  devicePackages,
  delSubscription,
  updateProgress,
  activateLicense,
  updateDeviceEvents,
  subscriptionIntent,
  reactivateSubscription,
};
